import React from 'react'
import Head from 'next/head'
import { Strings } from '../../../../components/profile/strings/Strings'
import { getStringUserIdFromHandleName } from 'api/user/profile-api'

// This gets called on every request
export async function getServerSideProps({params}) {
  // Fetch data from external API
  const handleName = params.handleName
  const stringsUserId = (await getStringUserIdFromHandleName(handleName)).toString()

  return {
    props: {
      handleName,
      stringsUserId
    },
  }
}

export default function Home(props) {
  const stringHandleName = props.handleName
  const stringsUserId = props.stringsUserId

  return (
    <>
      <Head>
        <title>Connections | StringsSG</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and many more..."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content="StringsSG - Connecting people with service providers" />
        <meta property="og:description" content="Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and many more..." />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/"/>
        <meta name="twitter:title" content="StringsSG - Connecting people with service providers"/> 
        <meta name="twitter:description" content="Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and many more..."/>
        <link rel="icon" href="/favicon.ico" />
      </Head>   
        <div className="max-w-4xl mx-auto overflow-hidden"> 
            <Strings stringHandleName={stringHandleName} stringsUserId={stringsUserId}/>
        </div>
    </>
  )
}
